import { RecordType } from '@xbcb/shared-types';
import { getRecordType } from '@xbcb/core';

export const isGenericBroker = (customsBrokerId?: string): boolean => {
  if (!customsBrokerId) return false;
  return getRecordType(customsBrokerId) === RecordType.BROKER;
};
